"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowTextEditor_1 = require("../../../../../../shared/components/editors/CardRowTextEditor");
var CardRowButtonSet_1 = require("../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var CardRowCheckBoxEditor_1 = require("../../../../../../shared/components/editors/CardRowCheckBoxEditor");
var CardRowNumericEditor_1 = require("../../../../../../shared/components/editors/CardRowNumericEditor");
var CardEditorContainer_1 = require("../../../../../../shared/components/containers/CardEditorContainer");
var AffilateSmtpCfgEditor = /** @class */ (function (_super) {
    __extends(AffilateSmtpCfgEditor, _super);
    function AffilateSmtpCfgEditor(props) {
        return _super.call(this, props) || this;
    }
    AffilateSmtpCfgEditor.prototype.componentWillMount = function () {
        var _this = this;
        if (this.props.record != null) {
            this.props.data.LoadData(this.props.record.key, function () {
                _this.setState({
                    smtp_server: _this.props.data.DATA.smtp_server,
                    smtp_port: _this.props.data.DATA.smtp_port,
                    smtp_user: _this.props.data.DATA.smtp_user,
                    smtp_password: _this.props.data.DATA.smtp_password,
                    smtp_use_ssl: _this.props.data.DATA.smtp_use_ssl,
                    smtp_from_email: _this.props.data.DATA.smtp_from_email
                });
            });
        }
        this.setState({
            smtp_server: "",
            smtp_port: 0,
            smtp_user: "",
            smtp_password: "",
            smtp_use_ssl: false,
            smtp_from_email: ""
        });
        this.doReSetRules();
        this.props.state.setExtBreadCrumbPath(["Настройка SMTP партнерской программы"]);
    };
    AffilateSmtpCfgEditor.prototype.doReSetRules = function () {
        this.setState({
            smtp_server_rules: { isError: false },
            smtp_port_rules: { isError: false },
            smtp_user_rules: { isError: false },
            smtp_password_rules: { isError: false },
            smtp_from_email_rules: { isError: false },
        });
    };
    AffilateSmtpCfgEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((!this.state.smtp_server) || (this.state.smtp_server.length === 0)) {
            this.setState({ smtp_server_rules: { isError: true, errorMessage: "Поле [smtp сервер] не заполнено!" } });
            return false;
        }
        if ((!this.state.smtp_user) || (this.state.smtp_user.length === 0)) {
            this.setState({ smtp_user_rules: { isError: true, errorMessage: "Поле [Логин пользователя] не заполнено!" } });
            return false;
        }
        if ((!this.state.smtp_password) || (this.state.smtp_password.length === 0)) {
            this.setState({ smtp_password_rules: { isError: true, errorMessage: "Поле [Пароль пользователя] не заполнено!" } });
            return false;
        }
        if ((!this.state.smtp_port) || (isNaN(this.state.smtp_port))) {
            this.setState({ smtp_port_rules: { isError: true, errorMessage: "Поле [smtp порт] не заполнено!" } });
            return false;
        }
        else {
            if ((this.state.smtp_port < 0) || (this.state.smtp_port > 64000)) {
                this.setState({ smtp_port_rules: { isError: true, errorMessage: "Поле [smtp порт] имеет недопустимое значение" } });
                return false;
            }
        }
        if ((!this.state.smtp_from_email) || (this.state.smtp_from_email.length === 0)) {
            this.setState({ smtp_from_email_rules: { isError: true, errorMessage: "Поле [Адрес отправителя] не заполнено!" } });
            return false;
        }
        return true;
    };
    AffilateSmtpCfgEditor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.EditData({
                pprogram_id: this.props.record.key,
                smtp_server: this.state.smtp_server,
                smtp_port: this.state.smtp_port,
                smtp_user: this.state.smtp_user,
                smtp_password: this.state.smtp_password,
                smtp_use_ssl: this.state.smtp_use_ssl,
                smtp_from_email: this.state.smtp_from_email
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Настройки SMTP партнерской программы изменены!");
            });
        }
    };
    AffilateSmtpCfgEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    AffilateSmtpCfgEditor.prototype.getFormTitle = function () {
        return "Изменить настройки SMTP партнерской программы";
    };
    AffilateSmtpCfgEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 480 },
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "SMTP сервер:", placeholder: "Введите SMTP сервер" }, value: this.state.smtp_server, onValueChanged: function (newVal) {
                    _this.setState({
                        smtp_server: newVal,
                        smtp_server_rules: { isError: false }
                    });
                }, required: true, rules: this.state.smtp_server_rules }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "SMTP порт:", placeholder: "Введите SMTP порт" }, values: { max: 64000, min: 0, value: this.state.smtp_port }, onValueChanged: function (newVal) {
                    _this.setState({
                        smtp_port: newVal,
                        smtp_port_rules: { isError: false }
                    });
                }, required: true, rules: this.state.smtp_port_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Логин пользователя:", placeholder: "Введите Логин пользователя" }, value: this.state.smtp_user, onValueChanged: function (newVal) {
                    _this.setState({
                        smtp_user: newVal,
                        smtp_user_rules: { isError: false }
                    });
                }, required: true, rules: this.state.smtp_user_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Пароль пользователя:", placeholder: "Введите пароль пользователя" }, value: this.state.smtp_password, onValueChanged: function (newVal) {
                    _this.setState({
                        smtp_password: newVal,
                        smtp_password_rules: { isError: false }
                    });
                }, required: true, rules: this.state.smtp_password_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Адрес отправителя:", placeholder: "Введите адрес отправителя" }, value: this.state.smtp_from_email, onValueChanged: function (newVal) {
                    _this.setState({
                        smtp_from_email: newVal,
                        smtp_from_email_rules: { isError: false }
                    });
                }, required: true, rules: this.state.smtp_from_email_rules }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Использовать SSL при подключении", value: this.state.smtp_use_ssl, onChecked: function (checked) {
                    _this.setState({ smtp_use_ssl: checked });
                } }),
            React.createElement(CardRowButtonSet_1.default, { editMode: true, title: { btnEdit: "Сохранить", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) })));
    };
    return AffilateSmtpCfgEditor;
}(React.Component));
exports.default = AffilateSmtpCfgEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/par_pprograms_list/ui/component/AffilateSmtpCfgEditor.tsx
// module id = 2037
// module chunks = 0